// Cookie
function setCookie(name, value, days) {
  const expires = new Date(
    Date.now() + days * 24 * 60 * 60 * 1000
  ).toUTCString();
  document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
}

function getCookie(name) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// Check cookie
if (!getCookie('promo_shown') && document.querySelector('.prime-video-block')) {
  const closeBtn = document.querySelector('.skip-video');
  const block = document.querySelector('.prime-video-block');

  // Показываем блок с анимацией fade-in
  block.style.opacity = 0;
  block.style.transition = 'opacity 0.5s';
  block.style.display = 'block';
  requestAnimationFrame(() => {
    block.style.opacity = 1;
  });

  // Close Block
  closeBtn.addEventListener('click', function () {
    block.style.opacity = 0;
    block.addEventListener('transitionend', function () {
      block.remove();
    });
    setCookie('promo_shown', '1', 1); // per day
  });
} else {
  // if cookie exist - remove block
  if (document.querySelector('.prime-video-block')) {
    document.querySelector('.prime-video-block').style.display = 'none';
  }
}
